<ng-container *ngIf="vm$ | async as vm">
<div class="od-toolbar">
  <label class="od-select"><span>Sobre qué:</span>
    <select aria-label="Sobre qué" [value]="filtro.sobre" (change)="elegirSobre($any($event.target).value)">
      <option *ngFor="let s of sobres; trackBy: porValor" [value]="s.valor" [selected]="filtro.sobre === s.valor">{{ s.texto }}</option>
    </select>
  </label>
  <label class="od-select"><span>Resultado:</span>
    <select aria-label="Resultado" [value]="filtro.ok" (change)="elegirResultado($any($event.target).value)">
      <option *ngFor="let r of resultados; trackBy: porValor" [value]="r.valor" [selected]="filtro.ok === r.valor">{{ r.texto }}</option>
    </select>
  </label>
  <label class="od-input" style="width: 220px">
    <od-icon name="search"></od-icon>
    <input type="search" [formControl]="buscar" placeholder="Buscar por nombre" aria-label="Buscar por nombre" maxlength="60">
  </label>
  <button type="button" class="od-btn od-btn-sm" (click)="recargar()" title="Volver a consultar" aria-label="Volver a consultar">
    <od-icon name="refresh"></od-icon>
  </button>
  <span class="od-fin" *ngIf="vm.hayDatos">{{ vm.total }} {{ vm.total === 1 ? 'movimiento' : 'movimientos' }} · {{ vm.conProblema }} con problema<ng-container *ngIf="pendientes$ | async as pend"> · Esperando envío {{ pend }}</ng-container></span>
</div>

  <div class="od-alert" *ngIf="vm.error" role="alert">
    <od-icon name="alert" [size]="16"></od-icon>
    <div class="od-alert-tx">
      <b>No se pudo traer la bitácora</b>
      <p class="od-muted">{{ vm.error }}</p>
    </div>
    <button type="button" class="od-btn od-btn-sm" (click)="recargar()">Reintentar</button>
  </div>

  <div aria-busy="true" *ngIf="vm.cargando && !vm.hayDatos && !vm.error">
    <div class="od-skeleton" style="height: 44px; margin-bottom: 8px" *ngFor="let i of esperando; trackBy: porIndice"></div>
  </div>

  <ng-container *ngIf="vm.hayDatos">
    <div class="od-empty" *ngIf="!vm.grupos.length">
      <od-icon name="history" [size]="22"></od-icon>
      <b>No hay movimientos con ese filtro</b>
      <span>Todo lo que se le avisa a Odoo queda anotado aquí durante 180 días.</span>
    </div>

    <div class="od-table-wrap" *ngIf="vm.grupos.length">
      <table class="od-table">
        <thead><tr><th>Hora</th><th>Qué pasó</th><th>Quién</th><th>Resultado</th></tr></thead>
        <tbody>
          <ng-container *ngFor="let g of vm.grupos; trackBy: porGrupo">
            <tr class="od-tr-grp"><td colspan="4">{{ g.titulo }}</td></tr>
            <tr class="od-row-click" *ngFor="let m of g.items; trackBy: porId" tabindex="0" [class.od-row-sel]="sel?._id === m._id"
                (click)="abrir(m)" (keydown.enter)="abrir(m)">
              <td class="od-muted" style="white-space: nowrap">{{ hora(m.createdAt) }}</td>
              <td class="od-td-max"><span style="font-weight: 600">{{ m.frase }}</span><span class="od-muted" *ngIf="m.nota"> {{ m.nota }}</span></td>
              <td class="od-muted" style="white-space: nowrap">{{ m.quien }}</td>
              <td>
                <span class="od-badge od-badge-solid" *ngIf="m.ok"><od-icon name="check" [size]="12"></od-icon>Bien</span>
                <span class="od-badge od-badge-problem" *ngIf="!m.ok"><od-icon name="alert" [size]="12"></od-icon>Con problema</span>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <od-paginador [page]="filtro.page" [limit]="limite" [total]="vm.total" unidad="movimientos" (cambiar)="irPagina($event)"></od-paginador>

    <od-sheet [abierto]="!!sel" [titulo]="sel ? sel.frase : ''" [subtitulo]="sel ? fechaHora(sel.createdAt) + ' · ' + sel.quien : ''" (cerrar)="cerrarPanel()">
      <div od-sheet-acciones *ngIf="sel as m">
        <span class="od-badge od-badge-solid" *ngIf="m.ok"><od-icon name="check" [size]="12"></od-icon>Bien</span>
        <span class="od-badge od-badge-problem" *ngIf="!m.ok"><od-icon name="alert" [size]="12"></od-icon>Con problema</span>
      </div>
      <od-evento-detalle *ngIf="sel" [evento]="sel"></od-evento-detalle>
    </od-sheet>
  </ng-container>
</ng-container>
